import { createFileRoute, redirect } from "@tanstack/react-router";

// No standalone "home" page exists in the v1 nav cut (TASK.md/PLAN.md R5) — the shell opens
// straight onto its first destination rather than an extra quiet state nothing links to.
export const Route = createFileRoute("/_authenticated/")({
  beforeLoad: () => {
    throw redirect({ to: "/catalog/products" });
  },
});
